import { useEffect, useState } from "react";
import {
  clearMetierMismatchSnooze,
  getMetierMismatchSnoozeUntil,
  METIER_SNOOZE_EVENT,
} from "./metierMismatchSnooze";

/** Rappel discret que la confirmation « Métier différent » est en sourdine, avec
 *  de quoi la réactiver : sans ça, une sourdine de 7 jours serait invisible et
 *  irréversible jusqu'à son échéance. */
export default function MetierSnoozeChip() {
  const [until, setUntil] = useState<number | null>(() => getMetierMismatchSnoozeUntil());

  useEffect(() => {
    const refresh = () => setUntil(getMetierMismatchSnoozeUntil());
    window.addEventListener(METIER_SNOOZE_EVENT, refresh);
    // L'échéance peut tomber pendant que la page reste ouverte.
    const timer = setInterval(refresh, 60 * 1000);
    return () => {
      window.removeEventListener(METIER_SNOOZE_EVENT, refresh);
      clearInterval(timer);
    };
  }, []);

  if (!until) return null;

  const endsAt = new Date(until).toLocaleString("fr-FR", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <button
      onClick={clearMetierMismatchSnooze}
      title={`Les placements hors métier sont forcés sans confirmation jusqu'au ${endsAt}`}
      className="flex flex-row items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-neutral-100 transition-colors"
      style={{ fontFamily: "Poppins", color: "#A16207", background: "#FEF9C3" }}
    >
      Alertes métier en sourdine
      <span style={{ textDecoration: "underline" }}>Réactiver</span>
    </button>
  );
}
